import "./Consulting.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import ResponsabilitaEnti231 from "./sections/ResponsabilitaEnti231";
import DoveTrovarci from "./sections/DoveTrovarci";
import InviaUnaRichiesta from "./sections/InviaUnaRichiesta";
import PrivacyEAI from "./sections/PrivacyEAI";
import DirittoCivileEContrattualistica from "./sections/DirittoCivileEContrattualistica";
import ArchitetturaContrattuale from "./sections/ArchitetturaContrattuale";
import ExtraordinaryOperations from "./sections/ExtraordinaryOperations";
import AssistanceTypes from "./sections/AssistanceTypes";
import CoreValues from "./sections/CoreValues";
import Footer from "@/reusable_sections/Footer";
import TextContent from "./sections/TextContent";
import StrategicBusinessShield from "./sections/StrategicBusinessShield";
import ArchitectureTextContent from "./sections/ArchitectureTextContent";
import SwissStyleTextSection from "./sections/SwissStyleTextSection";
export default function ConsultingPage() {
  return <div>
      <Header />
      <Hero />
      <ResponsabilitaEnti231 />
      <PrivacyEAI />
      <DirittoCivileEContrattualistica />
      <DoveTrovarci />
      <InviaUnaRichiesta />
      <SwissStyleTextSection />
      <ArchitetturaContrattuale />
      <ExtraordinaryOperations />
      <TextContent />
      <StrategicBusinessShield />
      <AssistanceTypes />
      <ArchitectureTextContent />
      <CoreValues />
      <Footer />
    </div>;
}